import { useState, useEffect, useRef, Fragment, memo, useContext } from "react";
import style from "./../index.module.scss";
import styleUi from "./ViewFolder.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import IconButton from '@mui/material/IconButton';
import PotItem from "./../../pages/Tab0/PotItem";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { CustomEventManager } from "../../comm/global/CustomEventManager";
import apiManager from '../../ApiManager';
import { GameContext } from "../../GameContext";
const customEventManager = new CustomEventManager();
const ViewFolder = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    const [selectedPot, set_selectedPot] = useState(-1);
    const { pocketlist,updatePocketlist } = useContext(GameContext);
    useEffect(() => {
        console.log("ViewFolder",arg);
        setInProp(true);
    }, [])
    
    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "ViewFolder"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app}>
                                <div className={styleUi.header}>
                                    <h2>{arg.folder.pocket_lists_name}</h2>
                                    {arg.type === "tab0" &&
                                        <IconButton onClick={e => {
                                            addModalType({
                                                cls: "EditPotList", arg: {
                                                    cb: (action) => {
                                                        switch (action) {
                                                            case "cancel":
                                                                break;
                                                            case "del":
                                                                console.log(arg.folder.pocket_lists_id);
                                                                apiManager.fetchDelete(`pocket-list/${arg.folder.pocket_lists_id}`).then(res=>{
                                                                    updatePocketlist("delList",arg.folder.pocket_lists_id);
                                                                    setInProp(false)
                                                                }).catch(err=>{
                                                                    alert(err);
                                                                    setInProp(false)
                                                                })
                                                                break;
                                                            case "edit":
                                                                addModalType({
                                                                    cls: "EditPotListAction", arg: {
                                                                        folder: arg.folder,
                                                                        cb: () => {
                                                                        }
                                                                    }
                                                                })
                                                                break;
                                                        }
                                                    }
                                                }
                                            })
                                        }}>
                                            <MoreHorizIcon />
                                        </IconButton>
                                    }
                                </div>
                                {arg.type === "selPot" &&
                                    <span>選擇一個地點加入</span>
                                }
                                <div className={styleUi.list}>
                                    {arg.folder.items.map((v, k) => {
                                        return <PotItem key={k} data={v} index={k} type={arg.type}
                                            showRadio={arg.type === "tab0" ? -1 : selectedPot === k ? 1 : 0}
                                            cb={index => {
                                                set_selectedPot(index);
                                            }} />
                                    })}
                                </div>
                                {arg.type === "selPot" &&
                                    <button disabled={selectedPot===-1} className={styleUi.bottomAdd} onClick={e => {
                                        customEventManager.dispatch("selPot", arg.folder.items[selectedPot]?.pocket_list_items_rewilding_detail
                                        );
                                    }}>
                                            加入行程
                                    </button>
                                }
                                <IconButton className={styleUi.back} onClick={e => {
                                    setInProp(false)
                                }}>
                                    <img src="./assets/ui/back.png" />
                                </IconButton>
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition >
        </div >
    );
}

export default memo(ViewFolder);